import type { KundeTokenDisplayInfo } from '@comparit/infrastructure';
import type { KundeStammdaten } from '../interfaces';

export const toKundeDisplayInfo = (
  stammdaten: KundeStammdaten | null | undefined
): KundeTokenDisplayInfo | undefined =>
  stammdaten?.vorname || stammdaten?.name || stammdaten?.email
    ? {
        vorname: stammdaten.vorname ?? '',
        name: stammdaten.name ?? '',
        email: stammdaten.email,
        mlpKundennummer: stammdaten.mlpKundennummer,
      }
    : undefined;
